export default __webpack_public_path__ + "static/media/coding.dd1bb322.svg";